import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import { fetchFeatureMenus } from '@/actions/menu';
import { fetchMenusTaxonomy } from '@/actions/menuTaxonomy';
import PageHeader from '@/components/common/PageHeader';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import MenuCategoryList from '@/components/menus/MenuCategoryList';
import MenuIndexListContainer from '@/containers/menus/MenuIndexListContainer';
import MenuTaxonomyCategoryListContainer from '@/containers/menus/MenuTaxonomyCategoryListContainer';
import MenuModalContainer from '@/containers/menus/MenuModalContainer';
import styles from 'styles/jss/original/pages/menus';
import { MENU_FEATURE_COOKING_POPULUR, MENU_FEATURE_NONE_COOKING_POPULUR } from '@/constants/app';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const MenusPage: NextPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.menu.title}
          description={meta.menu.description}
          image={meta.menu.image}
          url={meta.menu.url}
        />
        <PageHeader type='menu' />
        <div className={classes.main}>
          <MenuCategoryList />
          <MenuIndexListContainer />
          <MenuTaxonomyCategoryListContainer />
          <BottomBanner />
        </div>
        <MenuModalContainer />
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  const params = {
    menuFeatureCooking: MENU_FEATURE_COOKING_POPULUR,
    menuFeatureNoneCooking: MENU_FEATURE_NONE_COOKING_POPULUR
  };
  const menuParams = [params.menuFeatureCooking, params.menuFeatureNoneCooking];
  await Promise.all([
    (store.dispatch as AppDispatch)(fetchFeatureMenus(menuParams)),
    (store.dispatch as AppDispatch)(fetchMenusTaxonomy())
  ]);
});

export default MenusPage;
